module.exports = __webpack_public_path__ + "img/back.3c2060e0.png";